// video.js エントリーポイント（DVR あり）。
// ライブ配信（DVR 対応）とライブチェックでのみ使用する。
//
// 注意: videojs-dvr は import した時点で SeekBar.prototype.handleMouseMove 等の
// プロトタイプを DVR 向けに上書きする。VOD ページで読み込むとシークバーが壊れるため、
// DVR が必要なページだけでこのエントリーポイントを使うこと。

import videojs from '@/video_player/plugins';
// videojs-dvr: サイドエフェクトで registerPlugin('dvr', ...) と
// registerComponent('LiveButton', ...) が自動登録される。
// config/webpack/alias.js の video.js alias でインスタンスを統一済み。
import 'videojs-dvr';
import { createVodSettings, createLiveSettings } from '@/video_player/settings';
import { calc_viewing_time } from '@/video_player/utils';

window.HELP_IMPROVE_VIDEOJS = false;
window.videojs = videojs;
window.calc_viewing_time = calc_viewing_time;
window.createVodSettings = createVodSettings;
window.createLiveSettings = createLiveSettings;
